export type SupportedCurrencyCode = 'AED' | 'USD' | 'EUR' | 'GBP' | 'SAR' | 'QAR' | 'KWD' | 'BHD' | 'OMR';

export type CurrencyMeta = {
  code: string;
  symbol: string | null;
  display: string;
};

const CURRENCIES: Record<SupportedCurrencyCode, CurrencyMeta> = {
  AED: { code: 'AED', symbol: null, display: 'AED' },
  USD: { code: 'USD', symbol: '$', display: '$' },
  EUR: { code: 'EUR', symbol: '€', display: '€' },
  GBP: { code: 'GBP', symbol: '£', display: '£' },
  SAR: { code: 'SAR', symbol: null, display: 'SAR' },
  QAR: { code: 'QAR', symbol: null, display: 'QAR' },
  KWD: { code: 'KWD', symbol: null, display: 'KWD' },
  BHD: { code: 'BHD', symbol: null, display: 'BHD' },
  OMR: { code: 'OMR', symbol: null, display: 'OMR' },
};

export function getCurrencyMeta(currencyCode: string | null | undefined): CurrencyMeta {
  const code = String(currencyCode || '').trim().toUpperCase() as SupportedCurrencyCode;
  if (code in CURRENCIES) return CURRENCIES[code];
  const safe = code || 'AED';
  return { code: safe, symbol: null, display: safe };
}

export function getCurrencyDisplay(currencyCode: string | null | undefined): string {
  return getCurrencyMeta(currencyCode).display;
}

export function resolveCurrencyCode(params: {
  recordCurrency?: string | null | undefined;
  tenantCurrency?: string | null | undefined;
  platformCurrency?: string | null | undefined;
}): string {
  const record = String(params.recordCurrency || '').trim();
  if (record) return record;
  const tenant = String(params.tenantCurrency || '').trim();
  if (tenant) return tenant;
  const platform = String(params.platformCurrency || '').trim();
  if (platform) return platform;
  return 'AED';
}

export function formatCurrency(
  amount: number | string | null | undefined,
  currencyCode: string | null | undefined,
  options?: { maxDecimals?: number }
): string {
  const meta = getCurrencyMeta(currencyCode);
  const n = typeof amount === 'string' ? Number(amount) : (amount ?? 0);
  const value = Number.isFinite(n) ? n : 0;

  const inferredMax = Number.isInteger(value) ? 0 : 2;
  const maxDecimals = typeof options?.maxDecimals === 'number' ? Math.max(0, Math.min(6, options.maxDecimals)) : inferredMax;

  const numberText = value.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: maxDecimals,
  });

  if (meta.symbol) return `${meta.symbol}${numberText}`;
  return `${meta.code} ${numberText}`;
}
